export default __webpack_public_path__ + "static/media/bloodywall.b4d9f24f.png";